import { Danger } from "iconsax-reactjs";
import { useTranslation } from "react-i18next";
import { DIAGNOSTIC_STEP_PERMISSION_ERROR_KEY } from "@/constants/diagnostics";
import { selectDiagnosticsError } from "@/store/features/diagnostics/selectors";
import { ErrorTypes } from "@/store/features/diagnostics/types";
import { useAppSelector } from "@/store/hooks";
import { Button } from "@/ui";
import { getDeviceErrorPaneContent } from "@/utils/errors";
import DiagnosticsSection from "../DiagnosticsSection";

const Video = () => {
  const { t, i18n } = useTranslation();

  const error = useAppSelector(selectDiagnosticsError);

  console.log('error', error);

  const onClickRefresh = () => {
    window.location.reload();
  };

  if (error?.type !== ErrorTypes.permissions) {
    return null;
  }

  const { headline, message } = getDeviceErrorPaneContent(error.error);

  return (
    <DiagnosticsSection id={DIAGNOSTIC_STEP_PERMISSION_ERROR_KEY}>
      <div className="section-wrapper">
        <div className="section-content">
          <h2>
            <Danger
              size="28"
              color="var(--color-danger)"
              variant="Bold"
            />
            {t(headline)}
          </h2>
          <p>{t(message)}</p>
          <p>
            <b>
              {t('permissions_error_description_4')}
            </b>
          </p>
          <Button onClick={onClickRefresh}>{t('refresh_page')}</Button>
        </div>
        <div className="section-image">
          <img src={`/images/permission-error-${i18n.language}.webp`} alt={t(headline)} />
        </div>
      </div>
    </DiagnosticsSection>
  );
};

export default Video;